module.exports = {
  VIEW: 'PROMOLINKS_VIEW',
  ADD: 'PROMOLINKS_ADD',
  REMOVE: 'PROMOLINKS_REMOVE',
  EDIT: 'PROMOLINKS_EDIT'
}
